var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, EntityBuilder, Type } from '@decahedron/entity';
import { BotInstruction } from 'packages/bot/entities/BotInstruction';
import { BotAction } from 'packages/bot/entities/BotAction';
import uuid from 'uuid/v4';
var ConversationEntry = /** @class */ (function (_super) {
    __extends(ConversationEntry, _super);
    function ConversationEntry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = null;
        _this.source = null;
        _this.value = null;
        _this.createdAt = null;
        _this.id = uuid();
        return _this;
    }
    ConversationEntry.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        if (jsonData.type === 'instruction') {
            this.source = EntityBuilder.buildOne(BotInstruction, jsonData.source);
        }
        if (jsonData.type === 'action') {
            this.source = EntityBuilder.buildOne(BotAction, jsonData.source);
        }
        return this;
    };
    return ConversationEntry;
}(Entity));
export { ConversationEntry };
var BotConversation = /** @class */ (function (_super) {
    __extends(BotConversation, _super);
    function BotConversation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.messages = [];
        _this.botId = null;
        _this.talentId = null;
        _this.createdAt = null;
        _this.source = null;
        _this.updatedAt = null;
        _this.bot = null;
        return _this;
    }
    __decorate([
        Type(ConversationEntry),
        __metadata("design:type", Array)
    ], BotConversation.prototype, "messages", void 0);
    __decorate([
        Type(Object),
        __metadata("design:type", Object)
    ], BotConversation.prototype, "bot", void 0);
    return BotConversation;
}(Entity));
export { BotConversation };
